export const DRAFT='DRAFT'
export const INPROCESS='INPROCESS'
export const CLOSED='CLOSED'